import { API_BASE, apiGet } from "@/lib/api";

// ---------------------------------------------------------------------------
// Redirecionamentos (301/302) — lidos de cms_redirects e aplicados no site.
// ---------------------------------------------------------------------------

export interface RedirectRule {
  from_path: string;
  to_path: string;
  status_code: number;
}

const IGNORED_PREFIXES = ["/admin"];

function normalizePath(p: string): string {
  let s = (p || "").trim();
  s = s.split("?")[0].split("#")[0];
  if (!s.startsWith("/")) s = "/" + s;
  if (s.length > 1) s = s.replace(/\/+$/, "");
  return s;
}

export async function fetchRedirects(): Promise<RedirectRule[]> {
  try {
    const data = await apiGet<{ ok: boolean; data?: RedirectRule[] }>("/functions/v1/get-redirects");
    return data.data ?? [];
  } catch {
    return [];
  }
}

export function findRedirect(rules: RedirectRule[], pathname: string): RedirectRule | null {
  const target = normalizePath(pathname);
  if (IGNORED_PREFIXES.some((p) => target === p || target.startsWith(`${p}/`))) return null;
  for (const rule of rules) {
    if (normalizePath(rule.from_path) === target) return rule;
  }
  return null;
}

export { normalizePath as normalizeRedirectPath };

// Registra um acesso redirecionado (alimenta o contador de uso no painel).
// É fire-and-forget: nunca deve atrapalhar a navegação do visitante.
export async function trackRedirect(fromPath: string): Promise<void> {
  try {
    await fetch(`${API_BASE}/functions/v1/get-redirects`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ from_path: fromPath }),
    });
  } catch {
    // silencioso — apenas métrica
  }
}